import { forwardRef, useContext } from "react";

import { Radio, RadioProps } from "emoreg/molecules/radio";

import { GroupedRadioContext } from "../context";

export type RadioItemProps = Omit<
  RadioProps<string>,
  "checked" | "id" | "hasError" | "error" | "aria-labelledby" | "onChange" | "name"
>;

export const RadioItem = forwardRef<HTMLInputElement, RadioItemProps>(
  ({ value, ...props }, ref) => {
    const ctx = useContext(GroupedRadioContext);

    return (
      <Radio
        {...props}
        ref={ref}
        name={ctx.name}
        id={`${ctx.name}_${value}`}
        hasError={ctx.hasError}
        value={value}
        checked={ctx.value === value}
        aria-labelledby={ctx["aria-labelledby"]}
        onChange={ctx.onChange}
      />
    );
  }
);
